import { render, staticRenderFns } from "./OrderTransport.vue?vue&type=template&id=f7965a46&scoped=true"
import script from "./OrderTransport.vue?vue&type=script&lang=js"
export * from "./OrderTransport.vue?vue&type=script&lang=js"
import style0 from "./OrderTransport.vue?vue&type=style&index=0&id=f7965a46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7965a46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7965a46')) {
      api.createRecord('f7965a46', component.options)
    } else {
      api.reload('f7965a46', component.options)
    }
    module.hot.accept("./OrderTransport.vue?vue&type=template&id=f7965a46&scoped=true", function () {
      api.rerender('f7965a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/OrderTransport.vue"
export default component.exports